import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const KeywordAnalyzer = () => {
  const [keyword, setKeyword] = useState('');
  const [analyzing, setAnalyzing] = useState(false);

  const keywordData = [
    {
      keyword: "content management system",
      volume: "18,100",
      difficulty: 72,
      cpc: "$12.50",
      trend: "up",
      opportunity: "high"
    },
    {
      keyword: "cms platform",
      volume: "9,900",
      difficulty: 65,
      cpc: "$10.20",
      trend: "stable",
      opportunity: "medium"
    },
    {
      keyword: "website builder",
      volume: "74,000",
      difficulty: 85,
      cpc: "$15.80",
      trend: "up",
      opportunity: "low"
    },
    {
      keyword: "seo tools",
      volume: "33,100",
      difficulty: 78,
      cpc: "$18.90",
      trend: "up",
      opportunity: "medium"
    },
    {
      keyword: "content editor",
      volume: "5,400",
      difficulty: 45,
      cpc: "$8.30",
      trend: "stable",
      opportunity: "high"
    }
  ];

  const handleAnalyze = () => {
    setAnalyzing(true);
    setTimeout(() => {
      setAnalyzing(false);
    }, 1500);
  };

  const getDifficultyColor = (difficulty) => {
    if (difficulty >= 70) return 'text-red-600 bg-red-50';
    if (difficulty >= 50) return 'text-amber-600 bg-amber-50';
    return 'text-green-600 bg-green-50';
  };

  const getOpportunityColor = (opportunity) => {
    if (opportunity === 'high') return 'text-green-600 bg-green-50';
    if (opportunity === 'medium') return 'text-blue-600 bg-blue-50';
    return 'text-gray-600 bg-gray-50';
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 md:p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center">
          <Icon name="Search" size={20} className="text-blue-600" />
        </div>
        <div>
          <h2 className="text-lg md:text-xl font-semibold text-gray-900">Keyword Research</h2>
          <p className="text-sm text-gray-600">Discover high-value keywords for your content</p>
        </div>
      </div>
      <div className="flex gap-2 mb-6">
        <div className="flex-1">
          <Input
            type="text"
            placeholder="Enter keyword or phrase..."
            value={keyword}
            onChange={(e) => setKeyword(e?.target?.value)}
          />
        </div>
        <Button
          variant="default"
          iconName="Search"
          loading={analyzing}
          onClick={handleAnalyze}
        >
          Analyze
        </Button>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-200">
              <th className="text-left py-3 px-2 text-xs md:text-sm font-medium text-gray-700">Keyword</th>
              <th className="text-left py-3 px-2 text-xs md:text-sm font-medium text-gray-700">Volume</th>
              <th className="text-left py-3 px-2 text-xs md:text-sm font-medium text-gray-700">Difficulty</th>
              <th className="text-left py-3 px-2 text-xs md:text-sm font-medium text-gray-700">CPC</th>
              <th className="text-left py-3 px-2 text-xs md:text-sm font-medium text-gray-700">Trend</th>
              <th className="text-left py-3 px-2 text-xs md:text-sm font-medium text-gray-700">Opportunity</th>
            </tr>
          </thead>
          <tbody>
            {keywordData?.map((item, index) => (
              <tr key={index} className="border-b border-gray-100 hover:bg-gray-50">
                <td className="py-3 px-2 text-xs md:text-sm text-gray-900 font-medium">{item?.keyword}</td>
                <td className="py-3 px-2 text-xs md:text-sm text-gray-600">{item?.volume}</td>
                <td className="py-3 px-2">
                  <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getDifficultyColor(item?.difficulty)}`}>
                    {item?.difficulty}
                  </span>
                </td>
                <td className="py-3 px-2 text-xs md:text-sm text-gray-600">{item?.cpc}</td>
                <td className="py-3 px-2">
                  <Icon
                    name={item?.trend === 'up' ? 'TrendingUp' : 'Minus'}
                    size={16}
                    className={item?.trend === 'up' ? 'text-green-600' : 'text-gray-400'}
                  />
                </td>
                <td className="py-3 px-2">
                  <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getOpportunityColor(item?.opportunity)}`}>
                    {item?.opportunity}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default KeywordAnalyzer;